import { useQuery } from '@tanstack/react-query';
import { getOptionGroups } from '../../api/apiOptionGroups';

/**
 * Hook to fetch all active option groups for select components
 */
export const useGetOptionGroupsForSelect = () => {
    const { data, isLoading, error } = useQuery({
        queryKey: ['option-groups-select'],
        queryFn: () => getOptionGroups({ per_page: 100, is_active: 1 }),
        retry: false,
    });

    return {
        options: data?.data?.data || [],
        isLoading,
        error
    };
};
